<template>
  <div v-loading="loading">
    <div class="title">我的出题</div>
    <div class="mb-12">
      <el-select
        class="w-150 mr-12"
        v-model="stack_id"
        size="medium"
        filterable
        remote
        reserve-keyword
        clearable
        placeholder="关联技能点"
        prefix-icon="el-icon-search"
        :remote-method="remoteMethod"
        :loading="selectLoading"
      >
        <el-option
          v-for="point in skill_points"
          :key="point.id"
          :label="point.name"
          :value="point.id"
        ></el-option>
      </el-select>
      <el-input
        class="w-150 mb-12 mr-12"
        placeholder="关联考点"
        prefix-icon="el-icon-search"
        v-model.trim="exam_tag"
        size="medium"
        clearable
        @change="search"
      >
      </el-input>
      <el-select
        v-model="program_language_id"
        class="w-150 mr-12"
        size="medium"
        clearable
        placeholder="请选择编程语言"
      >
        <el-option
          v-for="item in languageList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        >
        </el-option>
      </el-select>
      <el-select
        class="w-120 mb-12 mr-12"
        v-model="status"
        size="medium"
        placeholder="状态"
        clearable
        @change="search"
      >
        <el-option label="已提交" :value="1"></el-option>
        <el-option label="已通过" :value="2"></el-option>
        <el-option label="已拒绝" :value="3"></el-option>
        <el-option label="废弃" :value="4"></el-option>
      </el-select>
      <el-input
        class="w-150 mb-12 mr-12"
        placeholder="标题"
        prefix-icon="el-icon-search"
        v-model.trim="title"
        size="medium"
        clearable
        @change="search"
      >
      </el-input>
      <el-select
        class="w-120 mr-12"
        v-model="question_type"
        clearable
        @change="search"
        placeholder="题目类别"
        size="medium"
      >
        <el-option label="场景" :value="4"></el-option>
        <el-option label="概念" :value="2"></el-option>
        <el-option label="代码" :value="3"></el-option>
        <el-option label="其他" :value="1"></el-option>
      </el-select>
      <el-cascader
        v-model="common_industry_id"
        :options="industryList"
        :props="optionProps"
        placeholder="请选择行业分类"
        size="medium"
        class="w-132 mr-12"
        @change="search"
        clearable
      ></el-cascader>
      <el-button type="primary" size="medium" plain @click="search"
        >查询</el-button
      >
      <el-button size="medium" @click="clearSearch">重置</el-button>
      <zhu-button
        class="float-btn"
        v-if="
          authPermissions.includes(
            'coding.api.jiker_fuwu_admin.questions.store'
          )
        "
        text="去出题"
        :shadow="true"
        size="medium"
        type="primary"
        @click="goAssignTopic"
      >
      </zhu-button>
    </div>
    <el-table :data="targetList" :stripe="true">
      <el-table-column width="80" label="编号" prop="id"></el-table-column>
      <el-table-column
        width="110"
        label="任务优先级"
        prop="required_total_number"
      >
        <template slot="header">
          <div>
            任务优先级<el-tooltip>
              <div slot="content">
                代表任务的紧急程度P1（非常紧急）～P10（不紧急）
              </div>
              <i class="el-icon-question" style="margin-left: 5px"></i>
            </el-tooltip>
          </div>
        </template>
        <template slot-scope="scope">
          <div v-if="scope.row.priority">P{{ scope.row.priority }}</div>
          <div v-else>-</div>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="关联技能点"
        prop="stack.name"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{
            scope.row.stacks.length ? getName(scope.row.stacks) : "-"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="关联考点"
        prop="stack.name"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{
            getName(scope.row.exam_tags)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="编程语言"
        prop="stack.name"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{
            String(scope.row.program_language_list)
          }}</span>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        label="标题"
        prop="stack.name"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <span style="margin-left: 10px">{{
            (scope.row.contents[0] ? scope.row.contents[0] : {}).title
          }}</span>
        </template>
      </el-table-column>
      <el-table-column width="80" label="难度等级">
        <template slot-scope="scope">
          <span v-if="scope.row.level === 1">R1-简单</span>
          <span v-if="scope.row.level === 2">R2-一般</span>
          <span v-if="scope.row.level === 3">R3-中等</span>
          <span v-if="scope.row.level === 4">R4-困难</span>
          <span v-if="scope.row.level === 5">R5-非常困难</span>
        </template>
      </el-table-column>
      <el-table-column label="关联行业" width="100" show-overflow-tooltip>
        <template slot-scope="scope">
          {{
            (scope.row.common_industries || []).length
              ? String(
                  scope.row.common_industries.map(data => {
                    return data.name;
                  })
                )
              : "-"
          }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="提交时间">
        <template slot-scope="scope">
          <i class="el-icon-time"></i>
          <span style="margin-left: 10px">{{ scope.row.created_at }}</span>
        </template>
      </el-table-column>
      <el-table-column width="120" label="状态" prop="status_desc">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.status === 1" type="warning" size="medium"
            >已提交</el-tag
          >
          <el-tag v-if="scope.row.status === 2" size="medium">已通过</el-tag>
          <el-tag v-if="scope.row.status === 3" type="danger" size="medium"
            >已拒绝</el-tag
          >
          <el-tag v-if="scope.row.status === 4" type="danger" size="medium"
            >废弃</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        v-if="
          authPermissions.includes('coding.api.jiker_fuwu_admin.questions.show')
        "
        width="55"
        label="操作"
      >
        <template slot-scope="scope">
          <el-link
            type="primary"
            :underline="false"
            @click="handleDetail(scope.row)"
            >详情</el-link
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total, prev, pager, next, jumper"
      @current-change="goPage"
      :current-page.sync="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      :hide-on-single-page="true"
    >
    </el-pagination>
  </div>
</template>

<script>
import { mapState } from "vuex";
import kcellService from "@/global/service/kcell";
// import skillService from "@/global/service/skill";
import codeService from "@/global/service/code";
// import ShowHideContent from "@/components/ShowHideContent";
// import SelectSkillStack from "@/components/SelectSkillStack.vue";
export default {
  // components: {
  //   // ShowHideContent,
  //   SelectSkillStack,
  // },
  data() {
    return {
      loading: true,
      status: null,
      isShow: false,
      selectLoading: false,
      stack_id: "",
      program_language_id: "",
      exam_tag: "",
      title: "",
      stack: null,
      level: null,
      languageList: [],
      targetList: [],
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      skill_points: [],
      chooseSkillStack: null,
      question_type: null,
      base_info: {},
      common_industry_id: null,
      industryList: [],
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
        emitPath: false
      }
    };
  },
  computed: {
    ...mapState(["authPermissions"]),
    getName() {
      return arr => {
        return arr.map(item => item.name).join("、");
      };
    }
  },
  created() {
    this.getData();
    this.getContent();
    this.getConst();
  },
  watch: {
    $route() {
      this.getData();
    }
  },
  methods: {
    getConst() {
      kcellService.kcellIndustry().then(res => {
        this.industryList = res;
      });
    },
    getData(status) {
      const page = Number(this.$route.query.page) || 1;
      const params = {
        page,
        page_size: this.pagination.pageSize,
        status: status ? status : this.status,
        stack_id: this.stack_id,
        exam_tag: this.exam_tag,
        program_language_id: this.program_language_id,
        title: this.title,
        type: this.question_type,
        common_industry_id: this.common_industry_id
      };
      this.loading = true;
      codeService
        .getMyQuestion(params)
        .then(res => {
          this.targetList = res.list;
          this.pagination.currentPage = Number(res.pagination.current_page);
          this.pagination.total = Number(res.pagination.total);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goAssignTopic() {
      this.$router.push({ name: "programTaskList" });
    },
    getContent() {
      codeService.getLanguageList().then(res => {
        this.languageList = res;
      });
    },
    goPage(val) {
      this.$router.push({
        name: "ProgramQuestionMy",
        query: { page: val }
      });
    },
    toggleShowContent() {
      this.isShow = !this.isShow;
    },
    search() {
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "ProgramQuestionMy",
          query: {}
        });
      }
      this.getData();
    },
    clearSearch() {
      this.status = null;
      this.title = "";
      this.question_type = null;
      this.stack_id = null;
      this.program_language_id = null;
      this.exam_tag = null;
      this.common_industry_id = null;
      // this.type = null
      if (JSON.stringify(this.$route.query) !== "{}") {
        this.$router.push({
          name: "ProgramQuestionMy",
          query: {}
        });
      }
      this.getData();
    },
    handleChangeSkillStack(e) {
      this.chooseSkillStack = e;
    },
    handleClick() {
      this.getData("-1");
    },
    handleDetail(data) {
      let url = this.$router.resolve({
        name: "ProgramQuestionMyDetail",
        params: { uuid: data.uuid }
      });
      window.open(url.href);
    },
    remoteMethod(query) {
      if (query !== "") {
        this.selectLoading = true;
        codeService
          .kcellSkills({ name: query })
          .then(res => {
            this.skill_points = res;
          })
          .finally(() => {
            this.selectLoading = false;
          });
      } else {
        this.skill_points = [];
      }
    }
  }
};
</script>

<style lang="less" scoped>
.float-btn {
  z-index: 10;
  float: right;
}
.hidden-redundant {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.toggle-show {
  cursor: pointer;
  .toggle-show-icon {
    margin-left: 4px;
  }
  &:hover {
    color: #409eff;
  }
}
.link {
  color: #409eff;
}
</style>
